import React from 'react';
import { Container } from 'semantic-ui-react';
import { map } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { Portal } from 'react-portal';
import {
  getBlocksFieldname,
  getBlocksLayoutFieldname,
  hasBlocksData,
  getBaseUrl,
  BodyClass,
} from '@plone/volto/helpers';
import config from '@plone/volto/registry';

const Contacts = ({ content, location }) => {
  const blocksFieldname = getBlocksFieldname(content);
  const blocksLayoutFieldname = getBlocksLayoutFieldname(content);
  const Image = config.getComponent('Image').component;

  return hasBlocksData(content) ? (
    <Container id="page-document" className="px-4">
      {content?.image && (
        <>
          <Portal
            node={__CLIENT__ && document.getElementById('portal-header-image')}
          >
            <div>
              <Image
                item={content}
                alt={content.caption ?? content.title}
                title={content.caption ?? content.title}
                key={content.image.download}
                sizes="100w"
                responsive={true}
              />
            </div>
          </Portal>
          <BodyClass className="has-image" />
        </>
      )}
      {map(content[blocksLayoutFieldname].items, (block) => {
        const Block =
          config.blocks.blocksConfig[
            content[blocksFieldname]?.[block]?.['@type']
          ]?.['view'] || null;
        return Block !== null ? (
          <Block
            key={block}
            id={block}
            properties={content}
            data={content[blocksFieldname][block]}
            path={getBaseUrl(location?.pathname || '')}
          />
        ) : (
          <div key={block}>
            <FormattedMessage
              id="Unknown Block"
              values={{ block: content[blocksFieldname][block]['@type'] }}
            />
          </div>
        );
      })}
    </Container>
  ) : (
    <Container id="page-document" className="px-4">
      <h1 className="documentFirstHeading">{content.title}</h1>
      {content.description && (
        <p className="documentDescription">{content.description}</p>
      )}
      {content.image && (
        <Image
          className="document-image float-end"
          item={content}
          alt={content.caption ?? content.title}
          title={content.caption ?? content.title}
          key={content.image.download}
          sizes="300px"
          responsive={true}
        />
      )}
      {/* {content.remoteUrl && (
        <span>
          The link address is:
          <a href={content.remoteUrl}>{content.remoteUrl}</a>
        </span>
      )} */}
      {content.text && (
        <div
          dangerouslySetInnerHTML={{
            __html: content.text.data,
          }}
        />
      )}
    </Container>
  );
};

export default Contacts;
